module.exports = __webpack_public_path__ + "static/media/24.ca17b871.png";